import type { GenerateBaseMetadataProps } from '@/app/utils/metadata';
import type { LcvNewsCategory } from '@/types/tis-cms/types';

export const NEWS_ACTIVITIES_URL = '/news-activities';

export const NEWS_ACTIVITIES_META_DATA: GenerateBaseMetadataProps = {
  title: 'ข่าวสารและกิจกรรม',
  description: 'ติดตามข่าวสารและกิจกรรมต่างๆ ของอีซูซุได้ที่นี่',
  url: NEWS_ACTIVITIES_URL,
};

export const NEWS_ACTIVITIES_PAGE = {
  title: 'ข่าวสารและกิจกรรม',
  description: 'ติดตามข่าวสารและกิจกรรมต่างๆ ของอีซูซุได้ที่นี่',
};

export function buildNewsCategoriesCategories(
  entries: LcvNewsCategory[],
  activeUrl?: string
) {
  return [
    {
      category: 'all',
      name: 'ทั้งหมด',
      url: NEWS_ACTIVITIES_URL,
      active: !activeUrl,
    },
    ...entries.map((entry) => ({
      category: entry.url ?? '',
      name: entry.title ?? '',
      url: `${NEWS_ACTIVITIES_URL}/${entry.url ?? ''}`,
      active: entry.url === activeUrl,
    })),
  ];
}
